module.exports = __webpack_public_path__ + "img/weixin.7ede58f3.png";